import { useSchedulingPersistence } from '../context/SchedulingPersistenceContext';

export default function useCalendarView() {
  const { calendarView } = useSchedulingPersistence();
  return calendarView;
}
